import initPage from '../initPage'

function ajax() {
  //console.log('ajax')

  String.prototype.trimSlash = function () {
    return this.replace(/^\/+|\/+$/gm, '')
  }
  String.prototype.trimHttp = function () {
    let text = this.replace(/(^\w+:|^)\/\//, '')
    return text
  }

  // load image
  //imgLoad()

  if ('scrollRestoration' in history) {
    history.scrollRestoration = 'manual'
  }

  window.pagesData = []
  window.preventPageChanging = false
  window.pageTransiType = false
  window.$linkTransi = false
  let currentPathname = document.location.pathname

  // History stage changed
  function historyStateChanged(e) {
    bus.emit('popstate')
    if (document.location.pathname == currentPathname) return
    currentPathname = document.location.pathname

    pageTransiType = false
    $linkTransi = false
    requestPage(window.location.href.trimHttp().trimSlash(), false)
  }
  function historyStateChangedForced(e) {
    bus.emit('popstate')
    currentPathname = document.location.pathname

    pageTransiType = false
    $linkTransi = false
    requestPage(window.location.href.trimHttp().trimSlash(), false)
  }

  // Save pages data for further use
  function savePagesData(url, data) {
    url = url.trimHttp().trimSlash().replace(/\/$/, '')
    pagesData[url] = data;
  }

  // Get pages data
  function getPagesData(url) {
    url = url.trimHttp().trimSlash().replace(/\/$/, '')
    return pagesData[url]
  }

  // link handler
  function linkHandler(e) {
    const $link = $(this)

    if ($link.is('[hreflang]')) return
    if ($link.is('[target="_blank"]')) return

    let linkHref = $link.attr('href')

    if (linkHref !== undefined) {
      if (linkHref.includes('mailto:') || linkHref.includes('tel:')) return
    }

    // trim http/slash + replace by localhost
    if (linkHref !== undefined) {
      //linkHref = linkHref.trimHttp().trimSlash()
      const hostname = location.hostname
      const portdot = location.port ? ':'+location.port : ''
      linkHref = linkHref.replace('127.0.0.1', hostname+portdot)
    }

    // if no-link = do nothing
    if (linkHref === undefined || $link.hasClass('remove-file') || $link.hasClass('no-link') || $link[0].hasAttribute('download')) {
      return
    }

    // href="#"
    if (linkHref.charAt(0) === '#') {
      e.preventDefault()
      if (linkHref.length === 1) return
      const $target = $(linkHref)
      if ($target.length) {
        let pos = $target.offset().top
        //TODO : plug scrollto
        //scrollto(pos)
        bus.emit('scrollto', pos, 1)
      }
      return
    }

    // if link HREF is current page, do nothing
    /*if (document.URL.trimSlash().trimHttp() === linkHref.trimSlash().trimHttp()) {
      //console.log('same URL, do nothing')
      e.preventDefault()
      $(window).trigger('trigger-navleave')
      return
    }*/

    //console.log(linkHref)

    // Check if it's an internal URL
    if (linkHref.trimSlash().trimHttp().indexOf(location.hostname) === 0) {
      e.preventDefault()
      if (window.preventPageChanging) return

      pageTransiType = $link.attr('page-transi-type') || false
      $linkTransi = $link

      // Load page
      requestPage(linkHref.trimHttp().trimSlash(), true)
    } else {
      e.preventDefault();
      window.open(linkHref, '_blank');
      return
    }
  }

  // page loading
  function requestPage(url, push) {
    window.preventPageChanging = true

    //scrollto(0, true)
    bus.emit('pageLeave')

    //return// debug mode

    url.trimHttp().trimSlash()
    //console.log(url)

    // Check if data exists
    const dataUrl = getPagesData(url)
    //console.log('data : '+data)


    function ajax(){
      $.get(location.protocol + '//' + url, function (data) {
        savePagesData(url, data)
        pageCreate(data)
      }).fail(function () {
        window.location = location.protocol + '//' + url
      })
    }
    function wait(){
      requestAnimationFrame(function(){
        setTimeout(function(){
          const dataThisUrl = getPagesData(url)
          ifing(dataThisUrl)
        }, 1000/10)
      })
    }

    function ifing(data){
      if (data === "loading") {
        wait()// check every 100ms if data is loaded
      } else if (data === "error" || data == undefined) {
        ajax()// not used in most case, data should already be loading from mouseenter event on <a>. Just a backup strat
      } else {
        pageCreate(data)
      }
    }
    ifing(dataUrl)



    if (push) {
      history.pushState(null, null, location.protocol + '//' + url)
    }

    currentPathname = document.location.pathname
  }






  // Create new page
  function pageCreate(data) {

    // Convert data to HTML
    const dataHtml = $('<div/>').html(data)

    // Create new container
    const $oldContainer = $('.mainpage')
    const $newContainer = dataHtml.find('.mainpage')
    $newContainer.addClass('mainpage__waiting')
    $newContainer.insertAfter($oldContainer.eq(0))


    function updatePage() {
      //console.log('try updatePage, status of prevent : ' + window.preventPageChanging)
      if (window.preventPageChanging) {
        requestAnimationFrame(updatePage)
        return
      }

      // Set title
      $('head title').html(dataHtml.find('title').html())

      // Switch nav/foot
      //$('.wp-foot').replaceWith(dataHtml.find('.wp-foot'))
      //$('.navbar--right').replaceWith(dataHtml.find('.navbar--right'))
      //$('.navbar--lang').replaceWith(dataHtml.find('.navbar--lang'))

      /*const $oldLang = $('.navbar--lang')
      const $newLang = dataHtml.find('.navbar--lang')
      $newLang.insertAfter($oldLang)
      $oldLang.remove()*/

      // analytics
      if (typeof ga !== 'undefined') {
        ga('set', {page: window.location.pathname, title: dataHtml.find('title').html()})
        ga('send', 'pageview')
      }
      if (typeof gtag !== 'undefined') {
        gtag('config', 'G-IDENTIFIANT', {'page_path': window.location.pathname});
      }
      if (typeof _paq !== 'undefined') {
        _paq.push(['setCustomUrl', window.location.pathname]);
        _paq.push(['setDocumentTitle', dataHtml.find('title').html()]);
        _paq.push(['trackPageView']);
      }

      // Switch
      $newContainer.removeClass('mainpage__waiting')
      $oldContainer.remove()

      /*if ($('.mainpage').length > 1) {
        setTimeout(function(){
          location.reload()
        }, 500)
      }*/

      bus.emit('pageEnter')
      initPage()// build stuff in new page
    }

    updatePage()
  }


  function prehtml(e){
    const $link = $(this)

    let linkHref = $link.attr('href')

    if ($link.hasClass('js-preload') || $link.hasClass('no-link') || $link.is('[target="_blank"]') || linkHref === undefined || linkHref.charAt(0) === '#') return
    if (linkHref.includes('mailto:') || linkHref.includes('tel:')) return

    linkHref = linkHref.trimHttp().trimSlash()
    const hostname = location.hostname
    const portdot = location.port ? ':'+location.port : ''
    linkHref = linkHref.replace('127.0.0.1', hostname+portdot)

    //if (document.URL.trimSlash().trimHttp() !== linkHref) return// same URL

    if (linkHref.indexOf(hostname) !== 0) return

    // prevent spam request
    $link.addClass('js-preload')
    // request page
    const data = getPagesData(linkHref)

    if (data == undefined) {
      savePagesData(linkHref, 'loading')
      $.get(location.protocol + '//' + linkHref, function (data) {
        savePagesData(linkHref, data)
      }).fail(function () {
        savePagesData(linkHref, 'error')
      })
    }
  }




  /**
   * init
  **/
  $('html').on('click', 'a', linkHandler)
  $('html').on('mouseenter', 'a', prehtml)
  $(window).bind('popstate', historyStateChanged)
  $(window).bind('forcepopstate', historyStateChangedForced)

}

export default ajax
